import { library } from '@fortawesome/fontawesome-svg-core';

import iconsInUse from './iconsInUse';

/**
 * @description initialize predefined set of fa icons for <Icon /> component
 */
library.add(...iconsInUse);
